import type { BffApiClient } from "@/app/api-client"
import type { InferRequestType } from "hono"

export type QueryInput = InferRequestType<
  BffApiClient["api"]["collections"][":id"]["traits"]["$get"]
>["param"]

export const getTraitsQueryParams = (
  apiClient: BffApiClient,
  queryInput: QueryInput,
) => {
  return {
    queryKey: ["collections", "traits", queryInput],
    queryFn: async () => {
      const response = await apiClient.api.collections[":id"].traits.$get({
        param: queryInput,
      })

      if (!response.ok) throw await response.json()

      return response.json()
    },
  }
}

type QueryFn = ReturnType<typeof getTraitsQueryParams>["queryFn"]

export type QueryResponse = Awaited<ReturnType<QueryFn>>
